import React, { useEffect } from "react";
import { UserInterface } from "../../../../store/sticker_maker/usersSlice";

import { Button, Form, Input } from "antd";
import FileDropzone from "../../../../componets/FileDropzone";

interface propsInterface {
  params?: UserInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <FileDropzone name='avatar' label='Avatar' preview={params?.avatar_url} />

      <Form.Item name='username' label="Name">
        <Input />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
